var _ = require('underscore')
  , urlUtils = require('@173js/url')
  , EMTPY = 'null'

exports.getNavClass = function(params) {
  var urlParams = this.urlParams
    , isCurrent = _.every(
        _.map(params, function(paramValue, paramKey) {
          paramValue = '' + paramValue

          return paramValue === urlParams[paramKey] ||
            paramValue === EMTPY && !urlParams[paramKey]
        })
      )

  return isCurrent ? 'current' : ''
}

function filterNullValue(obj) {
  var result = {}
  _.each(obj, function(value, key) {
    if (value === null) { return }
    result[key] = value
  })
  return result
}

exports.getFilterUrl = function(params) {
  var urlParams = this.urlParams
  ;delete urlParams.template;

  return urlUtils.addParam(
    this.currentListUrl
  , filterNullValue(_.extend(
        _.clone(urlParams)
      , params
    ))
  )
}
